import { ComponentPropsWithoutRef } from "react"

import { twMerge } from "tailwind-merge"

export type DashboardContentProps = ComponentPropsWithoutRef<"div">

/**
 * DashboardContent — layout section for dashboard pages that establishes content section styling as well as a container
 * query reference point.
 *
 * @params all div props
 *
 * @remarks
 * Adds Tailwind `@container` so any descendant utilities prefixed with `@...`
 * (e.g. `@md:flex-row`) respond to **this element's width**, not the viewport.
 * The *closest* `@container` ancestor is used, however you can also reference this container directly
 * by using `/dashboard-content` in your utility class (e.g. `@md/dashboard-content:block`).
 *
 */
export function DashboardContent({ className, children, ...restProps }: DashboardContentProps) {
  return (
    <div className={twMerge("@container/dashboard-content mx-6 max-w-6xl", className)} {...restProps}>
      {children}
    </div>
  )
}
